import {
  OutlinedArrowLeftMD,
  OutlinedArrowRightMD,
} from '@/components/elements/svgIcon/outlined';
import clsx from '@/helpers/clsx';
import { useScreen } from '@/hooks/useScreen';
import { Button } from '@mui/material';
import { useState } from 'react';
import SwiperClass, { Navigation, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import EnterpriseCourseCard, {
  IEnterpriseCourseCard,
} from '../../generals/EnterpriseCourseCard';
import SectionTitle from './SectionTitle';

interface IEnterpriseCourseSwiper {
  courses: IEnterpriseCourseCard[];
  sectionName: string;
  swiperClassname?: string;
}

const EnterpriseCourseSwiper = ({
  sectionName,
  courses,
  swiperClassname,
}: IEnterpriseCourseSwiper) => {
  const [controlledSwiper, setControlledSwiper] = useState<SwiperClass | null>(
    null
  );
  const { isDesktop } = useScreen();

  return (
    <>
      <div className="mb-4 flex items-center justify-between p-4 pb-0 lg:mb-8 lg:px-14">
        <SectionTitle
          sectionName={sectionName}
          textSize={isDesktop ? 'Large' : 'Small'}
        />
        <div className="flex items-center justify-between gap-2">
          <Button
            variant="rounded_medium_emphasis_v2"
            onClick={() => controlledSwiper?.slidePrev()}
          >
            <OutlinedArrowRightMD
              width={isDesktop ? 20 : 14}
              height={isDesktop ? 20 : 14}
            />
          </Button>
          <Button
            variant="rounded_medium_emphasis_v2"
            onClick={() => controlledSwiper?.slideNext()}
          >
            <OutlinedArrowLeftMD
              width={isDesktop ? 20 : 14}
              height={isDesktop ? 20 : 14}
            />
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1">
        <Swiper
          modules={[Pagination, Navigation]}
          direction="horizontal"
          mousewheel
          spaceBetween={12}
          slidesPerView={'auto'}
          onSwiper={(swiper) => setControlledSwiper(swiper)}
          className={clsx(
            '!m-0 w-full max-w-container !pl-4 lg:!pl-[72px]',
            swiperClassname
          )}
        >
          {courses.map((item, index) => {
            return (
              <SwiperSlide
                key={index}
                className="not-custom !mb-3 !h-auto !w-fit"
              >
                <EnterpriseCourseCard {...item} className="h-full" />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </>
  );
};

export default EnterpriseCourseSwiper;
